import {
    SET_IRRIGATION_MODE_SETTING,
    SET_WATERSAVING_MODE_SETTING,
    SET_BESTGROWING_MODE_SETTING,
    SET_VACATION_MODE_SETTING,
    SET_WORKING_MODE_SETTING,
    SET_NOTIFY_CONTACT_SETTING,
    SET_EMAIL_NOTIFICATION_SETTING,
    SET_VACATION_NOTIFICATIONS_SETTING,
    SET_FROST_NOTIFICATIONS_SETTING,
    SET_MOISTURE_LOW_NOTIFICATIONS_SETTING,
    SET_MOISTURE_HIGH_NOTIFICATIONS_SETTING,
    SET_MAX_WATERING_TIME_SETTING, SET_CONTACT_EMAIL_SETTING,
    SET_EMAIL_SETTING,
    SET_WATERING_TIME_AT_SETTING,
    SET_WATERING_TIME_SETTING,
    RESET_USER,
    GET_USER_SETTINGS
} from '../actions'

const INITIAL_STATE = {}

function settingsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_USER_SETTINGS:
            return action.payload.body || state
        case RESET_USER:
            return INITIAL_STATE
        case SET_IRRIGATION_MODE_SETTING:
            return {
                ...state,
                irrigationMode: action.payload,
            }
        case SET_WATERSAVING_MODE_SETTING:
            return {
                ...state,
                waterSavingMode: action.payload,
            }
        case SET_BESTGROWING_MODE_SETTING:
            return {
                ...state,
                bestGrowingMode: action.payload,
            }
        case SET_VACATION_MODE_SETTING:
            return {
                ...state,
                vacationMode: action.payload,
            }
        case SET_WORKING_MODE_SETTING:
            return {
                ...state,
                workingMode: action.payload,
            }
        case SET_NOTIFY_CONTACT_SETTING:
            return {
                ...state,
                notifyContactPerson: action.payload,
            }
        case SET_EMAIL_NOTIFICATION_SETTING:
            return {
                ...state,
                emailNotifications: action.payload,
            }
        case SET_VACATION_NOTIFICATIONS_SETTING:
            return {
                ...state,
                vacationNotifications: action.payload,
            }
        case SET_FROST_NOTIFICATIONS_SETTING:
            return {
                ...state,
                frostWarnings: action.payload,
            }
        case SET_MOISTURE_LOW_NOTIFICATIONS_SETTING:
            return {
                ...state,
                notificationMoistureLow: action.payload,
            }
        case SET_MOISTURE_HIGH_NOTIFICATIONS_SETTING:
            return {
                ...state,
                notificationMoistureHigh: action.payload,
            }
        case SET_MAX_WATERING_TIME_SETTING:
            return {
                ...state,
                maxWateringTime: action.payload,
            }
        case SET_CONTACT_EMAIL_SETTING:
            return {
                ...state,
                contactPersonMail: action.payload,
            }
        case SET_EMAIL_SETTING:
            return {
                ...state,
                emailAddress: action.payload,
            }
        case SET_WATERING_TIME_AT_SETTING:
            return {
                ...state,
                wateringTimeAt: action.payload,
            }
        case SET_WATERING_TIME_SETTING:
            return {
                ...state,
                wateringTime: action.payload,
            }
        default: return state
    }
}

export default settingsReducer



// WEBPACK FOOTER //
// ./src/reducers/settings.js